import { render, staticRenderFns } from "./ShowAll.vue?vue&type=template&id=587e9fd6&scoped=true"
import script from "./ShowAll.vue?vue&type=script&lang=js"
export * from "./ShowAll.vue?vue&type=script&lang=js"
import style0 from "./ShowAll.vue?vue&type=style&index=0&id=587e9fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587e9fd6",
  null
  
)

export default component.exports